module.exports = __webpack_public_path__ + "media/recipes/55-62f1b883.png";